export default __webpack_public_path__ + "static/media/nss-5.4bbcdc7a.png";